import { FaCheck } from 'react-icons/fa'
import { IoClose } from 'react-icons/io5'

const PasswordValidation = ({ password }: { password: string }) => {
  return (
    <div className="ml-4">
      <div className="flex items-center gap-2 mb-1">
        {password.length >= 8 ? (
          <FaCheck className="text-green-500" />
        ) : (
          <IoClose className="text-red-500" />
        )}
        <span
          className={`${
            password.length >= 8 ? 'text-green-500' : 'text-red-500'
          }`}
        >
          Tamanho mínimo de 8 caracteres
        </span>
      </div>
      <div className="flex items-center gap-2 mb-1">
        {/[!@#$%^&*(),.?":{}|<>]/.test(password) ? (
          <FaCheck className="text-green-500" />
        ) : (
          <IoClose className="text-red-500" />
        )}
        <span
          className={`${
            /[!@#$%^&*(),.?":{}|<>]/.test(password)
              ? 'text-green-500'
              : 'text-red-500'
          }`}
        >
          Deve conter pelo menos 1 caractere especial
        </span>
      </div>
      <div className="flex items-center gap-2 mb-1">
        {/[A-Z]/.test(password) ? (
          <FaCheck className="text-green-500" />
        ) : (
          <IoClose className="text-red-500" />
        )}
        <span
          className={`${
            /[A-Z]/.test(password) ? 'text-green-500' : 'text-red-500'
          }`}
        >
          Deve conter pelo menos 1 letra maiúscula
        </span>
      </div>
      <div className="flex items-center gap-2 mb-1">
        {/[a-z]/.test(password) ? (
          <FaCheck className="text-green-500" />
        ) : (
          <IoClose className="text-red-500" />
        )}
        <span
          className={`${
            /[a-z]/.test(password) ? 'text-green-500' : 'text-red-500'
          }`}
        >
          Deve conter pelo menos 1 letra minúscula
        </span>
      </div>
      <div className="flex items-center gap-2">
        {/\d/.test(password) ? (
          <FaCheck className="text-green-500" />
        ) : (
          <IoClose className="text-red-500" />
        )}
        <span
          className={`${
            /\d/.test(password) ? 'text-green-500' : 'text-red-500'
          }`}
        >
          Deve conter pelo menos 1 número
        </span>
      </div>
    </div>
  )
}

export default PasswordValidation
